/* eslint-disable no-unused-vars */

import React, { useCallback, useState } from 'react';

export default function useThrowAsyncError() {
  const [ error, setError ] = useState();

  return useCallback((e) => {
    setError(() => {
      throw e;
    });
  }, [ setError ]);
}
